export default __webpack_public_path__ + "images/918a6867e7270a6cc0b1ae876b971ffa-music_mobile-2.webp";